// src/pages/Admin/Views/SellerManagement/ViewContentIssuesModal.jsx
import React from 'react';

const ViewContentIssuesModal = ({ issues, onClose }) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3>Seller Content Issues</h3>
        <div style={styles.content}>
          {(issues && issues.length > 0) ? (
            <ul>
              {issues.map((issue, index) => (
                <li key={index} style={styles.listItem}>{issue}</li>
              ))}
            </ul>
          ) : (
            <p>No content issues found.</p>
          )}
        </div>
        <div style={styles.buttonGroup}>
          <button onClick={onClose} style={styles.primaryButton}>Close</button>
        </div>
      </div>
    </div>
  );
};

// --- Styles for Modal (can be shared or customized) ---
const styles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modal: { background: 'white', padding: '24px', borderRadius: '8px', width: '500px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
    content: { maxHeight: '300px', overflowY: 'auto', margin: '20px 0' },
    listItem: { marginBottom: '8px' },
    buttonGroup: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' },
    primaryButton: { padding: '10px 15px', border: 'none', backgroundColor: '#007bff', color: 'white', borderRadius: '4px', cursor: 'pointer' },
};

export default ViewContentIssuesModal;